import axiosInstance from "../../../helpers/api";

export const getLessonsByChapterID = (id) => {
  return axiosInstance.get(`/student/pdfs/${id}`);
};
